import(/* webpackMode: "eager" */ "/Users/christophkranebitter/renehuemer.com/website/src/app/global-error.tsx");
